// API Endpoint Constants
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://kccxf-84-241-18-148.run.pinggy-free.link';

export const API_ENDPOINTS = {
    // Auth Endpoints
    AUTH: {
        SEND_OTP: '/api/auth/send-otp',
        VERIFY_OTP: '/api/auth/verify-otp',
        COMPLETE_PROFILE: '/api/auth/complete-profile',
        LOGOUT: '/api/auth/logout',
    },

    // Admin Auth Endpoints (Admin only)
    ADMIN_AUTH: {
        LOGIN: '/api/admin/auth/login',
        LOGOUT: '/api/admin/auth/logout',
        VERIFY: '/api/admin/auth/verify',
        ME: '/api/admin/auth/me',
        ME_AVATAR: '/api/admin/auth/me/avatar',
    },

    // Staff Auth Endpoints (Admin + Operator)
    STAFF_AUTH: {
        ME: '/api/staff/auth/me',
        ME_AVATAR: '/api/staff/auth/me/avatar',
    },

    // User Endpoints
    USER: {
        PROFILE: '/api/user/profile',
        UPDATE_PROFILE: '/api/user/profile',
        AVATAR: '/api/user/profile/avatar',
    },

    // eKYC Endpoints (state machine)
    EKYC: {
        STATUS: '/api/ekyc/status',
        START: '/api/ekyc/start',
        PROFILE: '/api/ekyc/profile',
        CONSENT: '/api/ekyc/consent',
        SABTE_AHVAL: '/api/ekyc/sabte-ahval',
        SHAHKAR: '/api/ekyc/shahkar',
        ADDRESS: '/api/ekyc/address',
        FACE: '/api/ekyc/face',
        EVIDENCE: '/api/ekyc/evidence',
        CARD_FRONT: '/api/ekyc/card-front',
        CARD_BACK: '/api/ekyc/card-back',
        FACE_VIDEO: '/api/ekyc/face-video',
        COMPLETE: '/api/ekyc/complete',
        HISTORY: '/api/ekyc/history',
        LINKS: '/api/ekyc/links',
    },

    // Public KYC link (SMS flow, no auth)
    KYC_LINK: {
        RESOLVE: '/api/kyc-link/:token',
        PROFILE: '/api/kyc-link/:token/profile',
        CONSENT: '/api/kyc-link/:token/consent',
        TERMS_ACCEPT: '/api/kyc-link/:token/terms/accept',
        SABTE_AHVAL: '/api/kyc-link/:token/sabte-ahval',
        SHAHKAR: '/api/kyc-link/:token/shahkar',
        ADDRESS: '/api/kyc-link/:token/address',
        FACE: '/api/kyc-link/:token/face',
        EVIDENCE: '/api/kyc-link/:token/evidence',
        CARD_FRONT: '/api/kyc-link/:token/card-front',
        CARD_BACK: '/api/kyc-link/:token/card-back',
        FACE_VIDEO: '/api/kyc-link/:token/face-video',
        COMPLETE: '/api/kyc-link/:token/complete',
    },

    // Public payment link (SMS flow, no auth)
    PAYMENT_LINK: {
        RESOLVE: '/api/payments/link/:accessToken',
        SELECT_PRODUCT: '/api/payments/link/:accessToken/select-product',
        PAY: '/api/payments/link/:accessToken/pay',
        EVIDENCE: '/api/payments/link/:accessToken/evidence',
        OFFLINE_SUBMIT: '/api/payments/link/:accessToken/offline-submit',
    },

    // Certificate Endpoints
    CERTIFICATE: {
        LIST: '/api/certificates',
        DETAIL: '/api/certificates/:id',
        ISSUE: '/api/certificates/issue',
        REVOKE: '/api/certificates/:id/revoke',
        DOWNLOAD: '/api/certificates/:id/download',
        INSTALL_INFO: '/api/certificates/install-info',
        ISSUE_FROM_TOKEN: '/api/certificates/issue-from-token',
        REQUEST_STATUS: '/api/certificates/requests/:id',
    },

    // Pendar Koush staged issuance (Azma flows above are unchanged)
    PENDAR_CERTIFICATE: {
        REQUEST: '/api/certificates/pendar/request',
        AUTH_COMPLETE: '/api/certificates/pendar/auth-complete',
        INPERSON_AUTH: '/api/certificates/pendar/inperson-auth',
        ISSUE: '/api/certificates/pendar/issue',
        REVOKE: '/api/certificates/pendar/revoke',
        HISTORY: '/api/certificates/pendar/history',
    },

    // Public Pendar web-eKYC callback (provider callback - no auth)
    PENDAR_EKYC_CALLBACK: {
        CALLBACK: '/api/certificate-provider/pendar-koush/ekyc/callback',
    },

    // Signing Endpoints
    SIGNING: {
        SIGN_PDF: '/api/signing/sign-pdf',
        HISTORY: '/api/signing/history',
        DETAIL: '/api/signing/:id',
        DOWNLOAD: '/api/signing/:id/download',
    },

    // Billing Endpoints
    BILLING: {
        BALANCE: '/api/billing/balance',
        HISTORY: '/api/billing/history',
        RECORDS: '/api/billing/records',
        FEATURE_FLAGS: '/api/billing/feature-flags',
    },

    // Payment Endpoints
    PAYMENT: {
        CREATE: '/api/user/payments',
        LIST: '/api/user/payments',
        DETAIL: '/api/user/payments/:id',
        CONTINUE: '/api/user/payments/:id/continue',
        RETRY: '/api/user/payments/:id/retry',
        CANCEL: '/api/user/payments/:id/cancel',
        REQUIREMENT: '/api/user/payments/requirement',
        CERTIFICATE_PAYMENT: '/api/user/payments/certificate-payment',
        CALLBACK: '/api/payments/callback',
        LINK: '/api/payments/link/:accessToken',
        OFFLINE_SUBMIT: '/api/user/payments/:id/offline-submit',
    },

    // Admin Payment Management Endpoints (Admin only)
    ADMIN_PAYMENTS: {
        LIST: '/api/admin/payments',
        DETAIL: '/api/admin/payments/:id',
        AUDIT: '/api/admin/payments/:id/audit',
        LINK: '/api/admin/payments/:id/link',
        RECONCILIATION: '/api/admin/payments/reconciliation',
        FAILED: '/api/admin/payments/failed',
        RECONCILE: '/api/admin/payments/:id/reconcile',
        RECONCILE_BATCH: '/api/admin/payments/reconcile',
        MANUAL_VERIFY: '/api/admin/payments/:id/manual-verify',
        REFUND: '/api/admin/payments/:id/refund',
        COMPENSATE: '/api/admin/payments/compensate',
        SEND_LINK: '/api/admin/payments/send-link',
        OFFLINE_LIST: '/api/admin/payments/offline',
        OFFLINE_SUBMIT: '/api/admin/payments/:id/offline-submit',
        OFFLINE_APPROVE: '/api/admin/payments/:id/offline-approve',
        OFFLINE_REJECT: '/api/admin/payments/:id/offline-reject',
    },

    // Operator Payment Management Endpoints (Operator only)
    OPERATOR_PAYMENTS: {
        LIST: '/api/operator/payments',
        DETAIL: '/api/operator/payments/:id',
        AUDIT: '/api/operator/payments/:id/audit',
        LINK: '/api/operator/payments/:id/link',
        RECONCILIATION: '/api/operator/payments/reconciliation',
        FAILED: '/api/operator/payments/failed',
        RECONCILE: '/api/operator/payments/:id/reconcile',
        MANUAL_VERIFY: '/api/operator/payments/:id/manual-verify',
        SEND_LINK: '/api/operator/payments/send-link',
        OFFLINE_LIST: '/api/operator/payments/offline',
        OFFLINE_SUBMIT: '/api/operator/payments/:id/offline-submit',
        OFFLINE_APPROVE: '/api/operator/payments/:id/offline-approve',
        OFFLINE_REJECT: '/api/operator/payments/:id/offline-reject',
    },

    // Admin User Management Endpoints (Admin only)
    ADMIN_USERS: {
        LIST: '/api/admin/users',
        DETAIL: '/api/admin/users/:id',
        UPDATE: '/api/admin/users/:id',
        DELETE: '/api/admin/users/:id',
        CHECK_NATIONAL_CODE: '/api/admin/users/check-national-code/:nationalCode',
    },

    // Operator User Management Endpoints (Operator only - read)
    OPERATOR_USERS: {
        LIST: '/api/operator/users',
        DETAIL: '/api/operator/users/:id',
        CHECK_NATIONAL_CODE: '/api/operator/users/check-national-code/:nationalCode',
        SEARCH: '/api/operator/users/search',
        STATS: '/api/operator/users/stats',
    },

    // Admin User Group Management Endpoints
    ADMIN_USER_GROUPS: {
        LIST: '/api/admin/user-groups',
        DEFAULT: '/api/admin/user-groups/default',
        DETAIL: '/api/admin/user-groups/:id',
        UPDATE: '/api/admin/user-groups/:id',
        DELETE: '/api/admin/user-groups/:id',
        PROFILE: '/api/admin/user-groups/:id/profile',
        ACTIVATE: '/api/admin/user-groups/:id/activate',
        DEACTIVATE: '/api/admin/user-groups/:id/deactivate',
    },

    // Admin Certificate Profile Endpoints
    ADMIN_PROFILES: {
        LIST: '/api/admin/profiles',
        DETAIL: '/api/admin/profiles/:id',
    },

    // Admin Certificate Management Endpoints (Admin only)
    ADMIN_CERTIFICATES: {
        LIST: '/api/admin/certificates',
        SEARCH: '/api/admin/certificates/search',
        INSTALL_INFO: '/api/admin/certificates/user/:userId/install-info',
        ISSUE_FROM_TOKEN: '/api/admin/certificates/user/:userId/issue-from-token',
        REVOKE: '/api/admin/certificates/:id/revoke',
    },

    // Operator Certificate Management Endpoints (Operator only)
    OPERATOR_CERTIFICATES: {
        INSTALL_INFO: '/api/operator/certificates/user/:userId/install-info',
        ISSUE_FROM_TOKEN: '/api/operator/certificates/user/:userId/issue-from-token',
    },

    // Staff Operations Endpoints (Admin + Operator)
    STAFF_OPERATIONS: {
        DASHBOARD: '/api/staff/operations/dashboard',
        QUEUE: '/api/staff/operations/queue',
        QUEUE_DETAIL: '/api/staff/operations/queue/:id',
        QUEUE_RETRY: '/api/staff/operations/queue/:id/retry',
        QUEUE_CANCEL: '/api/staff/operations/queue/:id/cancel',
        DLQ: '/api/staff/operations/dlq',
        DLQ_DETAIL: '/api/staff/operations/dlq/:id',
        DLQ_RETRY: '/api/staff/operations/dlq/:id/retry',
        DLQ_RESOLVE: '/api/staff/operations/dlq/:id/resolve',
        COMPENSATION: '/api/staff/operations/compensation',
        COMPENSATION_DETAIL: '/api/staff/operations/compensation/:id',
        HEALTH: '/api/staff/operations/health',
    },

    // Operator eKYC Review Endpoints (Operator only)
    OPERATOR_EKYC: {
        STATUS: '/api/operator/ekyc/status',
        PENDING_REVIEW: '/api/operator/ekyc/pending-review',
        USER: '/api/operator/ekyc/users/:userId',
        SEND_LINK: '/api/operator/ekyc/links',
        PERFORM: '/api/operator/ekyc/users/:userId/perform',
        APPROVE: '/api/operator/ekyc/users/:userId/manual-approve',
        APPROVE_CHECK: '/api/operator/ekyc/users/:userId/approve-check',
        RE_RUN_CHECK: '/api/operator/ekyc/users/:userId/re-run-check',
        REJECT: '/api/operator/ekyc/users/:userId/manual-reject',
        REKYC_SKIP: '/api/operator/ekyc/users/:userId/rekyc/skip',
        REKYC_CONFIG: '/api/operator/ekyc/rekyc-config',
    },

    // Ticketing Endpoints
    TICKETS: {
        USER_LIST: '/api/user/tickets',
        USER_CREATE: '/api/user/tickets',
        USER_DETAIL: '/api/user/tickets/:id',
        USER_REPLY: '/api/user/tickets/:id/reply',
        USER_EVIDENCE: '/api/user/tickets/:id/evidence',
        USER_LINK: '/api/user/tickets/:id/links',
        OPERATOR_LIST: '/api/operator/tickets',
        OPERATOR_CREATE: '/api/operator/tickets',
        OPERATOR_DETAIL: '/api/operator/tickets/:id',
        OPERATOR_REPLY: '/api/operator/tickets/:id/reply',
        OPERATOR_EVIDENCE: '/api/operator/tickets/:id/evidence',
        OPERATOR_LINK: '/api/operator/tickets/:id/links',
        OPERATOR_ESCALATE: '/api/operator/tickets/:id/escalate',
        ADMIN_LIST: '/api/admin/tickets',
        ADMIN_CREATE: '/api/admin/tickets',
        ADMIN_DETAIL: '/api/admin/tickets/:id',
        ADMIN_REPLY: '/api/admin/tickets/:id/reply',
        ADMIN_EVIDENCE: '/api/admin/tickets/:id/evidence',
        ADMIN_LINK: '/api/admin/tickets/:id/links',
        ADMIN_STATUS: '/api/admin/tickets/:id/status',
        ADMIN_PRIORITY: '/api/admin/tickets/:id/priority',
        ADMIN_ASSIGN: '/api/admin/tickets/:id/assign',
        ADMIN_ESCALATE: '/api/admin/tickets/:id/escalate',
        ADMIN_AUDIT: '/api/admin/tickets/:id/audit',
    },

    // Document Evidence Endpoints
    EVIDENCE: {
        UPLOAD: '/api/evidence/upload',
        LIST: '/api/evidence',
        DETAIL: '/api/evidence/:id',
        DOWNLOAD: '/api/evidence/:id/download',
        REPLACE: '/api/evidence/:id/replace',
    },

    // Admin Product Management Endpoints
    ADMIN_PRODUCTS: {
        LIST: '/api/admin/products',
        DETAIL: '/api/admin/products/:id',
        UPDATE: '/api/admin/products/:id',
        DELETE: '/api/admin/products/:id',
        UPLOAD_IMAGE: '/api/admin/products/upload-image',
    },

    // Public Products Endpoints
    PRODUCTS: {
        LIST: '/api/products',
        DETAIL: '/api/products/:id',
    },

    // Admin Settings Endpoints
    ADMIN_SETTINGS: {
        LIST: '/api/admin/settings',
        UPDATE: '/api/admin/settings/:key',
    },

    // Operator/Admin Evidence Review Endpoints
    OPERATOR_EVIDENCE: {
        LIST: '/api/operator/evidence',
        DETAIL: '/api/operator/evidence/:id',
        DOWNLOAD: '/api/operator/evidence/:id/download',
        START_REVIEW: '/api/operator/evidence/:id/start-review',
        APPROVE: '/api/operator/evidence/:id/approve',
        REJECT: '/api/operator/evidence/:id/reject',
        ARCHIVE: '/api/operator/evidence/:id/archive',
    },

    // Maintenance Endpoints
    MAINTENANCE: {
        STATUS: '/api/maintenance/status',
    },

    // Terms & Conditions Endpoints
    TERMS: {
        ACTIVE: '/api/terms/active',
        STATUS: '/api/terms/status',
        ACCEPT: '/api/terms/accept',
    },

    // Admin Terms & Conditions Endpoints
    ADMIN_TERMS: {
        LIST: '/api/admin/terms',
        ACTIVE: '/api/admin/terms/active',
        CREATE: '/api/admin/terms',
        UPDATE: '/api/admin/terms/:id',
        ACTIVATE: '/api/admin/terms/:id/activate',
    },
};

// Helper function to replace URL parameters
export const buildUrl = (endpoint, params = {}) => {
    let url = endpoint;
    Object.keys(params).forEach(key => {
        url = url.replace(`:${key}`, params[key]);
    });
    return url;
};

// Helper function to get full URL
export const getFullUrl = (endpoint) => {
    const base = String(API_BASE_URL || '').replace(/\/+$/, '');
    const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    return `${base}${path}`;
};

export default API_ENDPOINTS;
